import { IconButton } from '@components/icon-button';
import { ListCard, ListCardProps } from '@components/list-card/list-card';

import { IconEdit } from '../icons/edit';

export type SettingsCardProps = ListCardProps & {
  onEdit?(): void;
};

export const SettingsCard = ({ onEdit, ...rest }: SettingsCardProps) => (
  <ListCard
    actions={
      onEdit ? (
        <IconButton variant="ghost-purple" onClick={onEdit} icon={<IconEdit />} />
      ) : undefined
    }
    {...rest}
  />
);
